var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-footer wraper-footer"},[_c('footer',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"logo-footer mb-2",attrs:{"src":"https://storage.googleapis.com/creators-static-1/images/logo-sm.svg"}})])])])])])
}]

export { render, staticRenderFns }